import Loadable from 'react-loadable';

import { CustomLoadableLoading } from '../../components/loading/loading.js';

const CompaniesPageAsync = Loadable({
	loader: () => import(/* webpackChunkName: "companies-page" */'./companies.page.js'),
	modules: ['./companies.page.js'],
	webpack: () => [require.resolveWeak('./companies.page.js')],
	loading: CustomLoadableLoading,
});

export default CompaniesPageAsync;
